export default "__VITE_ASSET__1JQRYAhH__"